<template>
  <v-container fluid class="py-4 px-2 px-md-6">
    <v-card class="pa-6 global-dashboard-card">
      <v-card-title class="text-h5 font-weight-bold">Gestión de Entidades</v-card-title>
      <!-- MODULOS -->
      <v-row class="mt-4" dense>
        <!-- CLIENTES -->
        <v-col cols="12" md="4">
          <v-card class="hoverable" @click="seleccionarModulo('clientes')">
            <v-card-title>Clientes</v-card-title>
            <v-card-text>Editar, agregar o desactivar clientes.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click.stop="abrirEditarCliente(null)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- AREAS -->
        <v-col cols="12" md="4">
          <v-card class="hoverable" @click="seleccionarModulo('areas')">
            <v-card-title>Áreas</v-card-title>
            <v-card-text>Administrar áreas asociadas a clientes.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click.stop="abrirEditarArea(null)"><v-icon>mdi-plus</v-icon></v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <!-- SUB ÁREAS -->
        <v-col cols="12" md="4">
          <v-card class="hoverable" @click="seleccionarModulo('subareas')">
            <v-card-title>Sub áreas</v-card-title>
            <v-card-text>Administrar sub áreas por cliente y área padre.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click.stop="abrirEditarSubArea(null)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>


        <!-- PROYECTOS -->
        <v-col cols="12" md="4">
          <v-card class="hoverable" @click="seleccionarModulo('proyectos')">
            <v-card-title>Proyectos</v-card-title>
            <v-card-text>Editar, agregar o eliminar proyectos por área.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click.stop="onAddProyecto"><v-icon>mdi-plus</v-icon></v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- GABINETES -->
        <v-col cols="12" md="4">
          <v-card class="hoverable" @click="seleccionarModulo('gabinetes')">
            <v-card-title>Gabinetes</v-card-title>
            <v-card-text>Gestionar gabinetes por proyecto.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click.stop="abrirEditarGabinete(null)"><v-icon>mdi-plus</v-icon></v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-divider class="my-6"></v-divider>

      <!-- CLIENTES -->
      <div v-if="moduloSeleccionado === 'clientes'">
        <h3 class="text-h6 font-weight-bold mb-4">Gestión de Clientes</h3>

        <v-data-table :headers="headersClientes" :items="clientesTabla" class="elevation-1" dense
          @click:row="onClickFilaCliente">
          <!-- Columna Estado con chip -->
          <template v-slot:[`item.estatus`]="{ item }">
            <v-chip :color="chipColor(item.estatus)" dark small>
              {{ item.estatus }}
            </v-chip>
          </template>

          <!-- Columna Acción con iconos -->
          <template v-slot:[`item.acciones`]="{ item }">
            <v-icon color="red" class="mr-2" @click.stop="solicitarEliminarCliente(item)">
              mdi-delete
            </v-icon>
            <v-icon color="grey darken-1" @click.stop="abrirEditarCliente(item)">
              mdi-pencil
            </v-icon>
          </template>

        </v-data-table>
      </div>

      <!-- Confirmación para Desactivar Clientes en Cascada(desactiva todo lo relacionado al cliente) -->
      <v-dialog v-model="confirmInactivar.visible" max-width="520px">
        <v-card>
          <v-card-title class="text-h6">Desactivar cliente</v-card-title>
          <v-card-text>
            Esto marcará al cliente
            <strong>{{ confirmInactivar.nombre }}</strong> como <strong>Inactivo</strong> y también
            desactivará en cascada sus <em>áreas, proyectos y gabinetes</em>. ¿Deseas continuar?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="cancelarInactivarCliente">Cancelar</v-btn>
            <v-btn color="red" dark @click="confirmarInactivarCliente">Sí, desactivar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- AREAS -->
      <div v-if="moduloSeleccionado === 'areas'">
        <h3 class="text-h6 font-weight-bold mb-4">Gestión de Áreas</h3>

        <v-select :items="clientes" v-model="clienteSeleccionado" item-text="name" item-value="id"
          :return-object="false" label="Selecciona un Cliente" class="mb-4" @change="cid => fetchAreas(cid)" />

        <v-data-table v-if="clienteSeleccionado" :headers="headersAreas" :items="areasTabla" dense class="elevation-1"
          @click:row="abrirEditarArea">
          <!-- Estado con chip -->
          <template v-slot:[`item.estatus`]="{ item }">
            <v-chip :color="chipColor(item.estatus)" dark small>
              {{ item.estatus }}
            </v-chip>
          </template>
          <!-- Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <v-icon color="grey darken-1" class="mr-2" @click.stop="abrirEditarArea(item)">
              mdi-pencil
            </v-icon>
            <v-icon color="red" @click.stop="solicitarEliminarArea(item)">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert type="info" class="ma-4" dense text>
              No hay áreas para este cliente.
            </v-alert>
          </template>
        </v-data-table>
      </div>

      <!-- SUB ÁREAS -->
      <div v-if="moduloSeleccionado === 'subareas'">
        <h3 class="text-h6 font-weight-bold mb-4">Gestión de Sub áreas</h3>

        <v-select :items="clientes" v-model="clienteSeleccionado" item-text="name" item-value="id"
          :return-object="false" label="Selecciona un Cliente" class="mb-2"
          @change="cid => { subAreaPadreSeleccionada = null; fetchAreas(cid) }" />

        <v-select :items="areasPadreFiltradas" v-model="subAreaPadreSeleccionada" item-text="name" item-value="id"
          label="Área padre" class="mb-4" clearable />

        <v-data-table v-if="clienteSeleccionado" :headers="headersSubAreas" :items="subAreasTabla" dense
          class="elevation-1" @click:row="abrirEditarSubArea">
          <template v-slot:[`item.estatus`]="{ item }">
            <v-chip :color="chipColor(item.estatus)" dark small>
              {{ item.estatus }}
            </v-chip>
          </template>

          <template v-slot:[`item.acciones`]="{ item }">
            <v-icon color="grey darken-1" class="mr-2" @click.stop="abrirEditarSubArea(item)">mdi-pencil</v-icon>
            <v-icon color="red" @click.stop="solicitarEliminarArea(item)">mdi-delete</v-icon>
          </template>

          <template v-slot:no-data>
            <v-alert type="info" class="ma-4" dense text>
              No hay sub áreas para este filtro.
            </v-alert>
          </template>
        </v-data-table>
      </div>


      <!-- PROYECTOS -->
      <div v-if="moduloSeleccionado === 'proyectos'">
        <h3 class="text-h6 font-weight-bold mb-4">Gestión de Proyectos</h3>

        <v-select :items="clientes" v-model="clienteSeleccionado" item-text="name" item-value="id" label="Cliente"
          class="mb-2" @change="cid => fetchAreas(cid)" />

        <v-select :items="areas" v-model="areaSeleccionada" item-text="name" item-value="id" label="Área" class="mb-4"
          @change="fetchProyectos" />

        <v-data-table v-if="areaSeleccionada" :headers="headersProyectos" :items="proyectosTabla" dense
          class="elevation-1" @click:row="abrirEditarProyecto">
          <!-- Estado con chip -->
          <template v-slot:[`item.estatus`]="{ item }">
            <v-chip :color="chipColor(item.estatus)" dark small>
              {{ item.estatus }}
            </v-chip>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <v-icon class="mr-2" color="grey darken-1" @click.stop="abrirEditarProyecto(item)">
              mdi-pencil
            </v-icon>
            <v-icon color="red" @click.stop="solicitarEliminarProyecto(item)">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert type="info" class="ma-4" dense text>
              No hay proyectos para esta área.
            </v-alert>
          </template>
        </v-data-table>
      </div>


      <!-- GABINETES -->
      <div v-if="moduloSeleccionado === 'gabinetes'">
        <h3 class="text-h6 font-weight-bold mb-4">Gestión de Gabinetes</h3>

        <v-select :items="clientes" v-model="clienteSeleccionado" item-text="name" item-value="id" label="Cliente" />
        <v-select :items="areas" v-model="areaSeleccionada" item-text="name" item-value="id" label="Área"
          :disabled="!clienteSeleccionado" />
        <v-select :items="proyectos" v-model="proyectoSeleccionado" item-text="project_code" item-value="id"
          label="Proyecto" :disabled="!areaSeleccionada" />

        <v-list v-if="gabinetes.length && proyectoSeleccionado">
          <v-list-item v-for="g in gabinetes" :key="g.id" class="gab-item" v-ripple>
            <v-list-item-content class="row-link" @click="irAGabinete(g)">
              {{ g.tag }} - {{ g.type }} - {{ g.estado }}
            </v-list-item-content>

            <v-list-item-action class="actions">
              <v-btn icon @click.stop="abrirEditarGabinete(g)"><v-icon>mdi-pencil</v-icon></v-btn>
              <v-btn icon @click.stop="solicitarEliminarGabinete(g)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>


        <v-alert v-else-if="proyectoSeleccionado && !gabinetes.length" type="info" outlined>
          No hay gabinetes para este proyecto.
        </v-alert>
      </div>
      <!-- Botón Volver -->
      <v-card-actions class="justify-end mt-4">
        <v-btn color="grey darken-3" @click="volverInicio">
          <v-icon left>mdi-home</v-icon>
          Volver a Inicio
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- Diálogos -->
    <!-- Diálogo Gestion Cliente -->
    <v-dialog v-model="dialogoEditarCliente" max-width="500px">
      <v-card>
        <v-card-title>{{ clienteEditando ? 'Editar Cliente' : 'Agregar Cliente' }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="clienteEditado.name" label="Nombre del Cliente" />

          <!-- Estado del cliente (solo relevante al editar) -->
          <v-select v-model="clienteEditado.estatus" :items="['Activo', 'Inactivo']" label="Estado del Cliente"
            :disabled="!clienteEditando" @change="onCambioEstadoCliente"
            hint="Si desactivas, se desactivarán en cascada las áreas, proyectos y gabinetes." persistent-hint />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoEditarCliente = false">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarEdicionCliente">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmación de desactivación en cascada -->
    <v-dialog v-model="confirmEstado.visible" max-width="520px">
      <v-card>
        <v-card-title class="text-h6">Confirmar desactivación</v-card-title>
        <v-card-text>
          Esto marcará al cliente como <strong>Inactivo</strong> y también dejará en
          <strong>Inactivo</strong> todas sus <em>áreas, proyectos y gabinetes</em>. ¿Deseas continuar?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="onCancelarCambioEstado">Cancelar</v-btn>
          <v-btn color="red" dark @click="onConfirmarCambioEstado">Sí, desactivar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Gestion Area -->
    <v-dialog v-model="dialogoEditarArea" max-width="500px">
      <v-card>
        <v-card-title>{{ areaEditando ? 'Editar Área' : 'Agregar Área' }}</v-card-title>
        <v-card-text>
          <v-select :items="clientes" v-model="areaEditada.client_id" item-text="name" item-value="id"
            label="Cliente" />
          <v-text-field v-model="areaEditada.name"
            :label="areaEditada.parent_area_id ? 'Nombre de la Sub área' : 'Nombre del Área'" />
          <v-select v-model="areaEditada.estatus" :items="['Activo', 'Inactivo']" label="Estado del Área" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoEditarArea = false">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarEdicionArea">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Confirmar activar/desactivar área -->
    <v-dialog v-model="confirmArea.visible" max-width="480px">
      <v-card>
        <v-card-title class="text-h6">
          {{ confirmArea.nextStatus === 'inactive' ? 'Desactivar área' : 'Activar área' }}
        </v-card-title>
        <v-card-text>
          ¿Seguro que deseas
          <strong>{{ confirmArea.nextStatus === 'inactive' ? 'desactivar' : 'activar' }}</strong>
          el área <strong>{{ confirmArea.area?.name }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarToggleArea">Cancelar</v-btn>
          <v-btn :color="confirmArea.nextStatus === 'inactive' ? 'red' : 'green'" dark @click="confirmarToggleArea">
            Sí, confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Gestión Sub área -->
    <v-dialog v-model="dialogoEditarSubArea" max-width="520px">
      <v-card>
        <v-card-title>{{ subAreaEditando ? 'Editar Sub área' : 'Agregar Sub área' }}</v-card-title>

        <v-card-text>
          <v-select :items="clientes" v-model="subAreaEditada.client_id" item-text="name" item-value="id"
            label="Cliente" :disabled="!!subAreaEditando"
            @change="(cid) => { subAreaEditada.parent_area_id = null; fetchAreas(cid); }" />


          <v-select :items="areasPadreParaDialogo" v-model="subAreaEditada.parent_area_id" item-text="name"
            item-value="id" label="Área padre" :disabled="!!subAreaEditando" />
          <v-text-field v-model="subAreaEditada.name" label="Nombre de la Sub área" />

          <v-select v-model="subAreaEditada.estatus" :items="['Activo', 'Inactivo']" label="Estado" />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoEditarSubArea = false">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarEdicionSubArea">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Confirmar eliminación de Cliente -->
    <v-dialog v-model="confirmEliminarCliente.visible" max-width="480px">
      <v-card>
        <v-card-title class="text-h6">Eliminar cliente</v-card-title>
        <v-card-text>
          ¿Estás seguro que deseas eliminar el cliente
          <strong>{{ confirmEliminarCliente.cliente?.name }}</strong>?
          <br />
          Esta acción eliminará en cascada todas sus <em>áreas, proyectos y gabinetes</em>.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarEliminarCliente">Cancelar</v-btn>
          <v-btn color="red" dark @click="confirmarEliminarCliente">
            Sí, eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Gestion Proyecto -->
    <v-dialog v-model="dialogoEditarProyecto" max-width="500px">
      <v-card>
        <v-card-title>{{ proyectoEditando ? 'Editar Proyecto' : 'Agregar Proyecto' }}</v-card-title>
        <v-card-text>
          <v-select :items="clientes" v-model="clienteSeleccionado" item-text="name" item-value="id" label="Cliente"
            @change="fetchAreas" />

          <v-select :items="areas" v-model="areaSeleccionada" item-text="name" item-value="id" label="Área"
            @change="onAreaForProyectoChange" />

          <!-- Sub área -->
          <v-select :items="subAreasProyecto" v-model="subAreaSeleccionada" item-text="name" item-value="id"
            label="Sub área" :disabled="!areaSeleccionada" />

          <v-text-field v-model="proyectoEditado.project_code" label="Código del Proyecto" />
          <v-text-field v-model="proyectoEditado.description" label="Descripción" />
          <v-text-field v-model="proyectoEditado.date" label="Fecha" placeholder="DD-MM-YYYY"
            @input="proyectoEditado.date = onFechaInput($event)" />
          <v-select :items="estadoProyectoOpciones" v-model="proyectoEditado.status" label="Estado" item-text="label"
            item-value="value" />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoEditarProyecto = false">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarEdicionProyecto">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Confirmar eliminación de Proyecto -->
    <v-dialog v-model="confirmProyecto.visible" max-width="480px">
      <v-card>
        <v-card-title class="text-h6">
          Eliminar proyecto
        </v-card-title>
        <v-card-text>
          ¿Estás seguro que deseas eliminar el proyecto
          <strong>{{ confirmProyecto.proyecto?.project_code }}</strong>?
          <br>
          Esta acción eliminará en cascada todos los <em>gabinetes</em> asociados.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarEliminarProyecto">Cancelar</v-btn>
          <v-btn color="red" dark @click="confirmarEliminarProyecto">
            Sí, eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirmar eliminación de archivos -->
    <v-dialog v-model="confirmEliminarArch.visible" max-width="520px">
      <v-card>
        <v-card-title class="text-h6">
          Eliminar {{ confirmEliminarArch.files.length }} archivo<span
            v-if="confirmEliminarArch.files.length !== 1">s</span>
        </v-card-title>
        <v-card-text>
          ¿Seguro que deseas eliminar
          <strong>
            <template v-if="confirmEliminarArch.files.length === 1">
              "{{ confirmEliminarArch.files[0]?.name }}"
            </template>
            <template v-else>
              estos {{ confirmEliminarArch.files.length }} archivos
            </template>
          </strong>
          del gabinete?
          <v-list two-line dense class="mt-3" v-if="confirmEliminarArch.files.length">
            <v-list-item v-for="f in confirmEliminarArch.files" :key="f.id">
              <v-list-item-content>
                <v-list-item-title>{{ f.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ formatBytes(f.size) }} • {{ f.mime || 'archivo' }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarEliminarArchivos">Cancelar</v-btn>
          <v-btn color="red" dark :loading="deletingFiles" @click="confirmarEliminarArchivos">
            Sí, eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmar eliminación de Gabinete -->
    <v-dialog v-model="confirmGabinete.visible" max-width="480px">
      <v-card>
        <v-card-title class="text-h6">Eliminar gabinete</v-card-title>
        <v-card-text>
          ¿Estás seguro que deseas eliminar el gabinete
          <strong>{{ confirmGabinete.gabinete?.tag }}</strong>?
          <br />
          Esta acción también eliminará sus archivos vinculados.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarEliminarGabinete">Cancelar</v-btn>
          <!-- 👇 aquí estaba el error -->
          <v-btn color="red" dark :loading="deletingGabinete" @click="confirmarEliminarGabinete">
            Sí, eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Diálogo Gestion Gabinete -->
    <v-dialog v-model="dialogoEditarGabinete" max-width="520px">
      <v-card>
        <v-card-title>{{ gabineteEditando ? 'Editar Gabinete' : 'Agregar Gabinete' }}</v-card-title>

        <v-card-text>
          <!-- Selecciones en cascada dentro del diálogo -->
          <v-select :items="clientes" v-model="dlgClienteId" item-text="name" item-value="id" :return-object="false"
            label="Cliente" :disabled="!!gabineteEditando" @change="onDlgClienteChange" />
          <v-select :items="dlgAreas" v-model="dlgAreaId" item-text="name" item-value="id" :return-object="false"
            label="Área" :disabled="!dlgClienteId || !!gabineteEditando" @change="onDlgAreaChange" />
          <v-select :items="dlgProyectos" v-model="dlgProyectoId" item-text="project_code" item-value="id"
            :return-object="false" label="Proyecto" :disabled="!dlgAreaId || !!gabineteEditando" />
          <v-text-field v-model="gabineteEditado.tag" label="Tag" />
          <v-text-field v-model="gabineteEditado.type" label="Tipo" />
          <v-select :items="estadoOpciones" v-model="gabineteEditado.estado" label="Estado" />
          <v-file-input v-model="dlgArchivos" label="Archivos del gabinete (máx. 10)" multiple counter show-size
            :rules="[files => (files?.length || 0) <= 10 || 'Máximo 10 archivos']"
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" />
          <!-- Archivos ya vinculados al gabinete -->
          <div v-if="gabineteEditando" class="mt-6">
            <div class="d-flex align-center mb-2">
              <h4 class="text-subtitle-1 font-weight-bold mb-0">Archivos vinculados</h4>
              <v-spacer />
              <v-btn small color="red" class="ml-2" :disabled="!dlgArchivosSeleccionados.length || deletingFiles"
                @click="eliminarArchivosSeleccionados">
                <v-icon left>mdi-delete</v-icon>
                Eliminar seleccionados
              </v-btn>
            </div>

            <v-data-table :headers="[
              { text: 'Nombre', value: 'name' },
              { text: 'Tamaño', value: 'size', width: 120 },
              { text: 'Fecha', value: 'created_at', width: 140 },
              { text: 'Tipo', value: 'mime', width: 160 },
              { text: 'Acciones', value: 'acciones', sortable: false, align: 'end', width: 110 },
            ]" :items="dlgArchivosVinculados" item-key="id" show-select v-model="dlgArchivosSeleccionados" dense
              class="elevation-1">

              <!-- tamaño legible -->
              <template v-slot:[`item.size`]="{ item }">
                <span>{{ formatBytes(item.size) }}</span>
              </template>

              <!-- fecha amigable -->
              <template v-slot:[`item.created_at`]="{ item }">
                <span>{{ formatFechaArchivo(item.created_at) }}</span>
              </template>

              <!-- acciones por fila -->
              <template v-slot:[`item.acciones`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" :href="item.url" target="_blank" rel="noopener"
                      v-if="item.url">
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Abrir</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small color="red" v-bind="attrs" v-on="on" :loading="deletingFiles"
                      @click="eliminarArchivoFila(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </template>

              <template v-slot:no-data>
                <v-alert type="info" text dense class="ma-2">
                  Este gabinete no tiene archivos vinculados.
                </v-alert>
              </template>
            </v-data-table>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogoGabinete">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarEdicionGabinete">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOGO  éxito / error -->
    <v-dialog v-model="feedback.visible" max-width="420px">
      <v-card :color="feedback.color" dark>
        <v-card-title class="align-center">
          <v-icon left large class="mr-2">{{ feedback.icon }}</v-icon>
          <span class="text-h6">{{ feedback.title }}</span>
        </v-card-title>

        <v-card-text class="white--text">
          {{ feedback.message }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="feedback.visible = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirmar eliminación de Área -->
    <v-dialog v-model="confirmEliminarArea.visible" max-width="480px">
      <v-card>
        <v-card-title class="text-h6">Eliminar área</v-card-title>
        <v-card-text>
          ¿Estás seguro que deseas eliminar el área
          <strong>{{ confirmEliminarArea.area?.name }}</strong>?
          <br />
          Esta acción eliminará en cascada todos sus <em>proyectos y gabinetes</em>.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarEliminarArea">Cancelar</v-btn>
          <v-btn color="red" dark @click="confirmarEliminarArea">
            Sí, eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Diálogo de carga mientras se guarda gabinete -->
    <v-dialog v-model="loadingGabinete" persistent max-width="320px">
      <v-card class="d-flex flex-column align-center justify-center pa-6">
        <v-icon large class="mb-3 spin">mdi-loading</v-icon>
        <span class="text-subtitle1 font-weight-medium">Creando Gabinete...</span>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import axios from 'axios';
import API_BASE from '@/helpers/api';

export default {
  data() {
    return {
      moduloSeleccionado: null,
      // Clientes
      clientes: [],
      clienteSeleccionado: null,
      clienteEditado: { name: '' },
      clienteEditando: null,
      dialogoEditarCliente: false,
      confirmEliminarCliente: { visible: false, cliente: null },
      clienteEstadoPrevio: 'Activo',
      confirmEstado: { visible: false },
      deactivacionConfirmada: false,
      confirmInactivar: { visible: false, id: null, nombre: '' },

      // Areas
      dialogoEditarArea: false,
      areaEditada: { name: '', client_id: null, sub_area: '' },
      areaEditando: null,

      headersAreas: [
        { text: 'Estado', value: 'estatus', width: 120 },
        { text: 'Área', value: 'area_col' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'end', width: 120 }
      ],

      // Sub áreas
      dialogoEditarSubArea: false,
      subAreaEditando: null,
      subareas: [],
      subAreaEditada: { name: '', client_id: null, parent_area_id: null, sub_area: '', estatus: 'Activo' },
      subAreaPadreSeleccionada: null,
      confirmEliminarSubArea: { visible: false, subarea: null },
      subAreasProyecto: [],
      subAreaSeleccionada: null,

      headersSubAreas: [
        { text: 'Estado', value: 'estatus', width: 120 },
        { text: 'Área', value: 'parent_name' },
        { text: 'Sub área', value: 'name' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'end', width: 120 }
      ],
      confirmArea: { visible: false, area: null, nextStatus: null },
      // Proyectos
      dialogoEditarProyecto: false,
      proyectoEditando: null,
      areas: [],
      proyectos: [],
      areaSeleccionada: null,
      estadoProyectoOpciones: [
        { label: 'En Desarrollo', value: 'development', color: 'green' },
        { label: 'Inactivo', value: 'inactive', color: 'red' }
      ],
      proyectoEditado: { project_code: '', description: '', date: '', status: 'development' },
      headersProyectos: [
        { text: 'Estado', value: 'estatus', width: 120 },
        { text: 'Proyecto', value: 'nombre' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'end', width: 120 }
      ],
      confirmProyecto: { visible: false, proyecto: null },
      loadingGabinete: false,


      // Gabinetes
      proyectoSeleccionado: null,
      gabinetes: [],

      dialogoEditarGabinete: false,
      gabineteEditando: null,
      gabineteEditado: { tag: '', type: '', estado: '' },
      // selects dentro del diálogo gabinetes
      dlgClienteId: null,
      dlgAreaId: null,
      dlgProyectoId: null,
      dlgAreas: [],
      dlgProyectos: [],
      estadoOpciones: ['Activo', 'Inactivo', 'En mantención'],
      dlgArchivos: [],
      confirmEliminarArea: { visible: false, area: null },
      // Archivos vinculados al gabinete (modo editar)
      dlgArchivosVinculados: [],
      dlgArchivosSeleccionados: [],
      confirmEliminarArch: { visible: false, files: [] },
      deletingFiles: false,
      // Dialogo exito/error
      feedback: {
        visible: false,
        title: '',
        message: '',
        color: 'green darken-2',
        icon: 'mdi-check-circle'
      },
      confirmGabinete: { visible: false, gabinete: null },
      deletingGabinete: false,
      feedbackTimer: null,


    }
  },
  computed: {
    headersClientes() {
      return [
        { text: 'Cliente', value: 'name' },
        { text: 'Estado', value: 'estatus' },
        { text: 'Acción', value: 'acciones', sortable: false }
      ];
    },
    clientesTabla() {
      return (this.clientes || []).map(c => ({
        ...c,
        estatus: c.estatus || c.status || 'Activo'
      }));
    },
    areasPadreParaDialogo() {
      const cid = Number(this.subAreaEditada?.client_id ?? this.clienteSeleccionado ?? 0);
      return (this.areas || []).filter(a => Number(a.client_id) === cid && a.parent_area_id == null);
    },

    proyectosTabla() {
      return (this.proyectos || []).map(p => {
        const raw = (p.estatus || p.status || '').toString().toLowerCase();

        // Normalizamos los estados a Español
        let estatus = 'En Desarrollo';
        if (raw === 'inactive' || raw === 'inactivo') estatus = 'Inactivo';
        else if (raw === 'development' || raw === 'en desarrollo') estatus = 'En Desarrollo';

        // nombre visible
        const nombre = p.project_code || p.name || p.description || `Proyecto ${p.id}`;

        return { ...p, estatus, nombre };
      });
    },
    areasTabla() {
      return (this.areas || []).map(a => {
        const raw = (a.estatus || a.status || '').toString().toLowerCase();
        const estatus = (raw === 'inactive' || raw === 'inactivo') ? 'Inactivo' : 'Activo';
        return {
          ...a,
          estatus,
          area_col: a.name,
          subarea_col: a.sub_area || ''
        };
      });
    },

    areasPadreFiltradas() {
      const cid = Number(this.valToId(this.clienteSeleccionado));
      return (this.areas || []).filter(a =>
        Number(a.client_id) === cid && (a.parent_area_id == null)
      );
    },

    subAreasTabla() {
      const pid = Number(this.valToId(this.subAreaPadreSeleccionada));
      const list = (this.subareas || []).filter(s => !pid || Number(s.area_id) === pid);

      return list.map(s => ({
        ...s,
        estatus: this.toSpanishStatus(s.status || s.estatus),
        parent_name: (this.areas.find(a => Number(a.id) === Number(s.area_id))?.name) || '(sin padre)',
      }));
    },


  },
  watch: {
    clienteSeleccionado() {
      if (['areas', 'proyectos', 'gabinetes', 'subareas'].includes(this.moduloSeleccionado)) {
        this.areaSeleccionada = null;
        this.proyectoSeleccionado = null;
        this.subAreaPadreSeleccionada = null;
        this.gabinetes = [];
        this.fetchAreas();
      }
    },
    subAreaPadreSeleccionada() {
      if (this.moduloSeleccionado === 'subareas') {
        this.subareas = [];
        this.fetchSubAreas();
      }
    },

    areaSeleccionada() {
      if (this.moduloSeleccionado === 'proyectos' || this.moduloSeleccionado === 'gabinetes') {
        this.proyectoSeleccionado = null;
        this.gabinetes = [];
        this.fetchProyectos();
      }
    },


    proyectoSeleccionado() {
      if (this.moduloSeleccionado === 'gabinetes') {
        this.fetchGabinetes();
      }
    },

  },
  methods: {
    seleccionarModulo(modulo) {
      this.moduloSeleccionado = modulo;
      this.clienteSeleccionado = null;
      this.areaSeleccionada = null;
      this.proyectoSeleccionado = null;
      this.subAreaPadreSeleccionada = null;
      this.areaEditada.client_id = null;
      this.areas = [];
      this.proyectos = [];
      this.gabinetes = [];
      this.fetchClientes();
    },

    valToId(v) {
      return v && typeof v === 'object' ? v.id : v;
    },
    chipColor(estatus) {
      const v = String(estatus || '').toLowerCase();

      if (v === 'activo' || v === 'active') return 'green';
      if (v === 'en desarrollo' || v === 'En Desarrollo') return 'green';
      if (v === 'inactivo' || v === 'inactive') return 'red';

      return 'grey';
    },
    solicitarEliminarCliente(cliente) {
      this.confirmEliminarCliente = { visible: true, cliente };
    },

    cancelarEliminarCliente() {
      this.confirmEliminarCliente = { visible: false, cliente: null };
    },

    async confirmarEliminarCliente() {
      const cliente = this.confirmEliminarCliente.cliente;
      if (!cliente) return;

      try {
        await axios.delete(`${API_BASE}/clients/${cliente.id}`);
        this.showSuccess(`Cliente "${cliente.name}" eliminado en cascada.`, "Cliente eliminado");
        await this.fetchClientes();
      } catch (err) {
        console.error("Error eliminando cliente:", err?.response?.data || err.message || err);
        this.showError("No se pudo eliminar el cliente.", "Error");
      } finally {
        this.cancelarEliminarCliente();
      }
    },

    solicitarToggleArea(a) {
      const activa = (a.estatus || '').toLowerCase() === 'activo' || (a.status || '').toLowerCase() === 'active';
      this.confirmArea = {
        visible: true,
        area: a,
        nextStatus: activa ? 'inactive' : 'active'
      };
    },


    async confirmarToggleArea() {
      const a = this.confirmArea.area;
      const clientId = this.valToId(this.clienteSeleccionado);
      if (!a || !clientId) return;

      const next = this.confirmArea.nextStatus;
      const accionOk = next === 'inactive' ? 'Área desactivada.' : 'Área activada.';

      try {
        await axios.put(`${API_BASE}/clients/${clientId}/areas/${a.id}`, {
          name: a.name,
          client_id: clientId,
          status: next
        });

        // reflejar de inmediato en la vista
        a.status = next;
        a.estatus = next === 'active' ? 'Activo' : 'Inactivo';

        this.showSuccess(accionOk);
        await this.fetchAreas(); // vuelve a recargar desde la API
      } catch (e) {
        this.showError('No se pudo cambiar el estado del área.');
        console.error('Error cambiando estado área:', e?.response?.data || e.message || e);
      } finally {
        this.cancelarToggleArea();
      }
    },

    cancelarToggleArea() {
      this.confirmArea = { visible: false, area: null, nextStatus: null };
    },
    solicitarEliminarArea(area) {
      this.confirmEliminarArea = { visible: true, area };
    },

    cancelarEliminarArea() {
      this.confirmEliminarArea = { visible: false, area: null };
    },

    async confirmarEliminarArea() {
      const area = this.confirmEliminarArea.area;
      const clientId = this.valToId(this.clienteSeleccionado);
      if (!area || !clientId) return;

      try {
        await axios.delete(`${API_BASE}/clients/${clientId}/areas/${area.id}`);
        this.showSuccess(`Área "${area.name}" eliminada en cascada.`, "Área eliminada");
        await this.fetchAreas();
      } catch (err) {
        console.error("Error eliminando área:", err?.response?.data || err.message || err);
        this.showError("No se pudo eliminar el área. Intenta nuevamente.", "Error");
      } finally {
        this.cancelarEliminarArea();
      }
    },


    abrirEditarSubArea(item) {
      this.subAreaEditando = item || null;

      const cid = Number(this.valToId(this.clienteSeleccionado) || item?.client_id || 0);
      const pid = Number(item?.area_id ?? this.valToId(this.subAreaPadreSeleccionada) ?? 0);

      this.subAreaEditada = item
        ? { id: item.id, client_id: cid, parent_area_id: pid, name: item.name || '', estatus: this.toSpanishStatus(item.status || item.estatus) }
        : { name: '', client_id: cid, parent_area_id: pid, estatus: 'Activo' };

      this.dialogoEditarSubArea = true;
      if (cid) this.fetchAreas(cid);
    },

    async fetchSubAreas(clienteIdParam, areaIdParam) {
      const cid = Number(clienteIdParam ?? this.valToId(this.clienteSeleccionado));
      const pid = Number(areaIdParam ?? this.valToId(this.subAreaPadreSeleccionada));
      this.subareas = [];
      if (!cid || !pid) return;

      try {
        const { data } = await axios.get(`${API_BASE}/clients/${cid}/areas/${pid}/subareas`);
        this.subareas = Array.isArray(data) ? data : (data?.rows || []);
      } catch (e) {
        console.error('fetchSubAreas()', e?.response?.data || e.message || e);
        this.showError('No se pudieron cargar las sub áreas.');
      }
    },

    async guardarEdicionSubArea() {
      const cid = Number(this.subAreaEditada.client_id);
      const pid = Number(this.subAreaEditada.parent_area_id);
      const name = (this.subAreaEditada.name || '').trim();
      const est = this.subAreaEditada.estatus;

      if (!cid || !pid || !name) return this.showError('Cliente, Área padre y nombre son obligatorios.');
      const toEnglish = s => (String(s).toLowerCase().startsWith('inac') ? 'inactive' : 'active');
      const payload = { name, status: toEnglish(est) };

      try {
        if (this.subAreaEditando) {
          await axios.put(`${API_BASE}/clients/${cid}/areas/${pid}/subareas/${this.subAreaEditando.id}`, payload);
          this.showSuccess('Sub área actualizada.');
        } else {
          await axios.post(`${API_BASE}/clients/${cid}/areas/${pid}/subareas`, payload);
          this.showSuccess('Sub área creada.');
        }
        this.dialogoEditarSubArea = false;
        await this.fetchSubAreas(cid, pid);
      } catch (e) {
        console.error('guardarEdicionSubArea', e?.response?.data || e.message);
        this.showError('No se pudo guardar la sub área.');
      }
    },


    onClickFilaCliente(payload) {
      const c = payload?.item ?? payload;
      this.abrirEditarCliente(c);
    },
    async fetchClientes() {
      const res = await axios.get(`${API_BASE}/clients`);
      this.clientes = res.data;
    },

    formatearFechaDDMMYYYY(fecha) {
      if (!fecha) return "";

      // YYYY-MM-DD -> DD-MM-YYYY
      const m = fecha.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m) return `${m[3]}-${m[2]}-${m[1]}`;

      return fecha; // Si ya está formateada
    },

    toISODate(fecha) {
      if (!fecha) return "";

      // DD-MM-YYYY -> YYYY-MM-DD
      const m = fecha.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (m) return `${m[3]}-${m[2]}-${m[1]}`;

      return fecha; // si ya viene bien
    },

    formatFecha(val) {
      if (!val) return '';

      // Si viene en ISO (2025-08-08T00:00:00.000Z)
      if (typeof val === 'string' && val.includes('T')) {
        val = val.split('T')[0];
      }

      // YYYY-MM-DD -> DD-MM-YYYY
      let m = String(val).match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m) return `${m[3]}-${m[2]}-${m[1]}`;

      // Ya en DD-MM-YYYY
      m = String(val).match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (m) return `${m[1]}-${m[2]}-${m[3]}`;

      // Último recurso: Date()
      const d = new Date(val);
      if (!isNaN(d)) {
        const dd = String(d.getUTCDate()).padStart(2, '0');
        const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
        const yyyy = d.getUTCFullYear();
        return `${dd}-${mm}-${yyyy}`;
      }

      return '';
    },

    onFechaInput(valor) {
      if (!valor) return "";
      // Eliminar caracteres no numéricos excepto -
      valor = valor.replace(/[^0-9-]/g, "");

      // Autoformatear DD-MM-YYYY mientras escribe
      if (/^\d{2}-\d{2}-\d{4}$/.test(valor)) {
        return valor;
      }

      // Insertar guiones automáticamente
      if (valor.length === 2 || valor.length === 5) {
        valor += "-";
      }
      return valor;
    },
    onCambioEstadoCliente(nuevo) {
      // si intenta desactivar y antes estaba Activo -> pedir confirmación
      if (this.clienteEstadoPrevio !== 'Inactivo' && nuevo === 'Inactivo') {
        this.confirmEstado.visible = true;
      } else {
        this.clienteEstadoPrevio = nuevo;
      }
    },
    onCancelarCambioEstado() {
      this.confirmEstado.visible = false;
      this.clienteEditado.estatus = this.clienteEstadoPrevio;
    },
    onConfirmarCambioEstado() {
      this.confirmEstado.visible = false;
      this.deactivacionConfirmada = true;
      this.clienteEstadoPrevio = 'Inactivo';
    },
    async fetchAreas(clientIdParam) {
      const clientId = clientIdParam ?? this.valToId(this.clienteSeleccionado);
      if (!clientId) { this.areas = []; return; }

      try {
        const { data } = await axios.get(`${API_BASE}/clients/${clientId}/areas`);
        this.areas = Array.isArray(data) ? data : (data?.rows || data?.areas || data?.data || []);
      } catch (e) {
        console.error('fetchAreas()', e?.response?.data || e.message || e);
        this.areas = [];
        this.showError('No se pudieron cargar las áreas.');
      }
    },
    async fetchSubAreasProyecto(clientIdParam, areaIdParam) {
      const cid = Number(clientIdParam ?? this.valToId(this.clienteSeleccionado));
      const aid = Number(areaIdParam ?? this.valToId(this.areaSeleccionada));
      this.subAreasProyecto = [];
      if (!cid || !aid) return;

      try {
        const { data } = await axios.get(`${API_BASE}/clients/${cid}/areas/${aid}/subareas`);
        this.subAreasProyecto = Array.isArray(data) ? data : (data?.rows || []);
      } catch (e) {
        console.error('fetchSubAreasProyecto()', e?.response?.data || e.message || e);
        this.showError('No se pudieron cargar las sub áreas.');
      }
    },

    onAreaForProyectoChange() {
      // Cuando cambia el área en el diálogo de proyecto
      this.subAreaSeleccionada = null;
      this.fetchSubAreasProyecto();
      // Si además quieres refrescar la grilla de proyectos (ya se hacía):
      this.fetchProyectos();
    },

    async fetchProyectos() {
      if (!this.areaSeleccionada || !this.clienteSeleccionado) return;
      const res = await axios.get(
        `${API_BASE}/clients/${this.clienteSeleccionado}/areas/${this.areaSeleccionada}/projects`
      );

      // Normaliza a DD-MM-YYYY al recibir
      this.proyectos = (res.data || []).map(p => ({
        ...p,
        date: this.formatFecha(p.date)
      }));
    },

    toSpanishStatus(s) {
      const v = String(s || '').toLowerCase();
      if (v === 'active' || v === 'activo') return 'Activo';
      if (v === 'inactive' || v === 'inactivo') return 'Inactivo';
      if (v === 'maintenance' || v === 'en mantención') return 'En Mantención'; // 👈 corregido
      return 'Activo';
    },
    toEnglishStatus(s) {
      const v = String(s || '').toLowerCase();
      if (v === 'activo' || v === 'active') return 'active';
      if (v === 'inactivo' || v === 'inactive') return 'inactive';
      if (v === 'en mantención' || v === 'maintenance') return 'maintenance'; // 👈 añadido
      return 'active';
    },

    abrirEditarCliente(cliente) {
      this.clienteEditando = cliente;

      if (cliente) {
        // Mapear status (inglés) o estatus (español) → estatus (español) para el select
        const est = this.toSpanishStatus(cliente.estatus ?? cliente.status ?? 'Activo');
        this.clienteEditado = { id: cliente.id, name: cliente.name, estatus: est };
      } else {
        this.clienteEditado = { name: '', estatus: 'Activo' };
      }

      this.clienteEstadoPrevio = this.clienteEditado.estatus;
      this.deactivacionConfirmada = false;
      this.dialogoEditarCliente = true;
    },
    async eliminarCliente(id) {
      if (!id) return;

      const ok = confirm("Esto eliminará el cliente y en cascada todas sus áreas, proyectos y gabinetes. ¿Deseas continuar?");
      if (!ok) return;

      try {
        await axios.delete(`${API_BASE}/clients/${id}`);
        this.showSuccess("Cliente eliminado en cascada.");
        await this.fetchClientes();
      } catch (err) {
        console.error("Error eliminando cliente:", err?.response?.data || err);
        this.showError("No se pudo eliminar el cliente.");
      }
    },
    async guardarEdicionCliente() {
      if (!this.clienteEditado.name) {
        this.showError("Debes ingresar un nombre para el cliente.", "Error de validación");
        return;
      }

      try {
        if (this.clienteEditando) {
          const id = this.clienteEditando.id;
          const nombreNuevo = String(this.clienteEditado.name || '').trim();
          const nombreActual = String(this.clienteEditando.name || '').trim();
          const nombreCambio = nombreNuevo !== nombreActual;

          if (nombreCambio) {
            await axios.put(`${API_BASE}/clients/${id}`, { name: nombreNuevo });
            this.showSuccess("Nombre del cliente actualizado.", "Cliente modificado");
          }

          // Normalizar ambos para comparar correctamente
          const prevRaw = this.clienteEditando.estatus ?? this.clienteEditando.status ?? 'Activo';
          const nuevoRaw = this.clienteEditado.estatus ?? 'Activo';
          const prevN = this.toEnglishStatus(prevRaw);
          const nuevoN = this.toEnglishStatus(nuevoRaw);
          const huboCambioEstado = prevN !== nuevoN;

          if (huboCambioEstado) {
            if (nuevoN === 'inactive') {
              if (!this.deactivacionConfirmada) {
                this.confirmEstado.visible = true;
                return;
              }
              try {
                await axios.put(`${API_BASE}/clients/${id}/inactivar`, { usuario: 'ui' });
                this.showSuccess('Cliente desactivado en cascada.', "Cliente modificado");
              } catch {
                try {
                  await axios.put(`${API_BASE}/clients/${id}/status`, { estatus: 'Inactivo', cascade: true });
                  this.showSuccess('Cliente desactivado.', "Cliente modificado");
                }
                catch {
                  try {
                    await axios.post(`${API_BASE}/clients/${id}/deactivate`);
                    this.showSuccess('Cliente desactivado.', "Cliente modificado");
                  }
                  catch {
                    this.showError('No se pudo desactivar el cliente.', "Error");
                  }
                }
              }
            } else {
              try {
                await axios.post(`${API_BASE}/clients/${id}/activar`, { usuario: 'ui' });
                this.showSuccess('Cliente activado.', "Cliente modificado");
              } catch {
                try {
                  await axios.post(`${API_BASE}/clients/${id}/activate`);
                  this.showSuccess('Cliente activado.', "Cliente modificado");
                }
                catch {
                  try {
                    await axios.put(`${API_BASE}/clients/${id}/status`, { estatus: 'Activo', cascade: true });
                    this.showSuccess('Cliente activado.', "Cliente modificado");
                  }
                  catch {
                    this.showError('No se pudo activar el cliente.', "Error");
                  }
                }
              }
            }
          }

          // 👉 Si no hubo cambios de nombre ni estado
          if (!nombreCambio && !huboCambioEstado) {
            this.showSuccess("No se detectaron cambios, cliente sin modificar.", "Aviso");
          }

        } else {
          await axios.post(`${API_BASE}/clients`, { name: String(this.clienteEditado.name || '').trim() });
          this.showSuccess("Cliente creado con éxito.", "Nuevo cliente");
        }

        this.dialogoEditarCliente = false;
        this.deactivacionConfirmada = false;
        await this.fetchClientes();

      } catch (err) {
        console.error('Error guardando cliente:', err?.response?.data || err.message || err);
        this.showError("No se pudo guardar el cliente.", "Error");
      }
    },
    solicitarInactivarCliente(c) {
      this.confirmInactivar.visible = true;
      this.confirmInactivar.id = c?.id || null;
      this.confirmInactivar.nombre = c?.name || '';
    },
    cancelarInactivarCliente() {
      this.confirmInactivar.visible = false;
      this.confirmInactivar.id = null;
      this.confirmInactivar.nombre = '';
    },
    async confirmarInactivarCliente() {
      const id = this.confirmInactivar.id;
      if (!id) return;
      try {
        await axios.put(`${API_BASE}/clients/${id}/inactivar`, { usuario: 'ui' });
        this.showSuccess('Cliente desactivado en cascada.');
      } catch (e1) {
        try {
          await axios.post(`${API_BASE}/clients/${id}/deactivate`);
          this.showSuccess('Cliente desactivado.');
        }
        catch { this.showError('No se pudo desactivar el cliente.'); }
      } finally {
        this.cancelarInactivarCliente();
        await this.fetchClientes();
      }
    },

    abrirEditarArea(area) {
      this.areaEditando = area;
      this.areaEditada = area
        ? {
          id: area.id,
          client_id: area.client_id || this.clienteSeleccionado || null,
          name: area.name || '',
          sub_area: area.sub_area || '',
          estatus: this.toSpanishStatus(area.status || area.estatus),
          parent_area_id: area.parent_area_id ?? null,
          parent_name: area.parent_name || null
        }
        : { name: '', client_id: this.clienteSeleccionado || null, sub_area: '', estatus: 'Activo', parent_area_id: null };

      this.dialogoEditarArea = true;
    },

    async guardarEdicionArea() {
      if (!this.areaEditada.name || !this.areaEditada.client_id) {
        this.showError("Debes ingresar un nombre y seleccionar un cliente.", "Error al guardar Área");
        return;
      }

      const payload = {
        name: this.areaEditada.name,
        client_id: this.areaEditada.client_id,
        status: this.toEnglishStatus(this.areaEditada.estatus || this.areaEditada.status),
        sub_area: (this.areaEditada.sub_area || '').trim() || null,
        parent_area_id: this.areaEditada.parent_area_id ?? null
      };

      try {
        if (this.areaEditando) {
          await axios.put(
            `${API_BASE}/clients/${this.areaEditada.client_id}/areas/${this.areaEditando.id}`,
            payload
          );
          this.showSuccess("Área actualizada con éxito.", "Área modificada");
        } else {
          await axios.post(`${API_BASE}/clients/${this.areaEditada.client_id}/areas`, payload);
          this.showSuccess("Área creada con éxito.", "Nueva Área");
        }

        this.dialogoEditarArea = false;
        this.fetchAreas();
      } catch (err) {
        console.error("Error guardando área:", err?.response?.data || err.message || err);
        this.showError("No se pudo guardar el área. Intenta nuevamente.", "Error");
      }
    },



    async eliminarArea(id) {
      const clientId = this.valToId(this.clienteSeleccionado);
      if (!clientId) {
        this.showError('Debes seleccionar un cliente antes de eliminar un área.');
        return;
      }

      const ok = confirm('Esto eliminará el área y todos sus proyectos y gabinetes en cascada. ¿Deseas continuar?');
      if (!ok) return;

      try {
        await axios.delete(`${API_BASE}/clients/${clientId}/areas/${id}`);
        this.showSuccess('Área eliminada en cascada.');
        await this.fetchAreas();
      } catch (err) {
        console.error('Error eliminando área:', err?.response?.data || err.message || err);
        this.showError('No se pudo eliminar el área.');
      }
    },

    abrirEditarProyecto(proyecto) {
      this.proyectoEditando = proyecto;
      this.proyectoEditado = proyecto
        ? { ...proyecto, date: this.formatearFechaDDMMYYYY(proyecto.date) }
        : { project_code: '', description: '', date: '', status: 'development' };

      this.subAreaSeleccionada = null;
      this.subAreasProyecto = [];


      const posibleSubId = Number(proyecto?.sub_area_id || proyecto?.subarea_id || proyecto?.subarea?.id);
      if (this.clienteSeleccionado && this.areaSeleccionada) {

        this.fetchSubAreasProyecto().then(() => {
          if (posibleSubId) this.subAreaSeleccionada = posibleSubId;
        });
      }

      this.dialogoEditarProyecto = true;
    },

    async guardarEdicionProyecto() {
      const p = this.proyectoEditado;
      if (!p.project_code || !p.description || !p.date || !p.status) {
        alert('Completa código, descripción, fecha y estado.');
        return;
      }
      const clientId = this.valToId(this.clienteSeleccionado);
      const areaId = this.valToId(this.areaSeleccionada);

      // 👉 NUEVO: sub área obligatoria
      const subAreaId = this.valToId(this.subAreaSeleccionada);
      if (!clientId || !areaId) {
        alert('Selecciona Cliente y Área antes de guardar.');
        return;
      }
      if (!subAreaId) {
        alert('Debes seleccionar una Sub área.');
        return;
      }

      const payload = {
        project_code: String(p.project_code || '').trim(),
        description: String(p.description || '').trim(),
        date: this.toISODate(p.date),
        status: p.status,
        sub_area_id: Number(subAreaId),
      };

      try {
        if (this.proyectoEditando) {
          await axios.put(
            `${API_BASE}/clients/${clientId}/areas/${areaId}/projects/${this.proyectoEditando.id}`,
            payload
          );
          this.showSuccess("Proyecto actualizado con éxito.");
        } else {
          await axios.post(
            `${API_BASE}/clients/${clientId}/areas/${areaId}/projects`,
            payload
          );
          this.showSuccess("Proyecto creado con éxito.");
        }

        this.dialogoEditarProyecto = false;
        this.proyectoEditado = {};
        await this.fetchProyectos();
      } catch (err) {
        console.error("Error guardando proyecto:", err?.response?.data || err.message || err);
        this.showError("No se pudo guardar el proyecto.");
      }
    },

    async updateProyectoApi({ clientId, areaId, id, payload }) {
      const attempts = [
        // Rutas comunes directas sobre el recurso
        { m: 'patch', u: `${API_BASE}/projects/${id}` },
        { m: 'put', u: `${API_BASE}/projects/${id}` },
        { m: 'post', u: `${API_BASE}/projects/${id}` },

        // Variante "singular"
        { m: 'patch', u: `${API_BASE}/project/${id}` },
        { m: 'put', u: `${API_BASE}/project/${id}` },

        // Rutas anidadas
        { m: 'put', u: `${API_BASE}/clients/${clientId}/areas/${areaId}/projects/${id}` },
        { m: 'post', u: `${API_BASE}/clients/${clientId}/areas/${areaId}/projects/${id}` },

        // Upsert al listado (id en el body)
        { m: 'put', u: `${API_BASE}/projects`, body: { ...payload, id } },
        { m: 'post', u: `${API_BASE}/projects`, body: { ...payload, id } },
        { m: 'put', u: `${API_BASE}/clients/${clientId}/areas/${areaId}/projects`, body: { ...payload, id } },
        { m: 'post', u: `${API_BASE}/clients/${clientId}/areas/${areaId}/projects`, body: { ...payload, id } },

        // Algunos backends exponen /update
        { m: 'post', u: `${API_BASE}/projects/${id}/update` },
      ];

      for (const a of attempts) {
        try {
          const body = a.body ?? payload;
          const res = await axios[a.m](a.u, body);
          if (res?.status >= 200 && res.status < 300) return res;
        } catch (err) {
          const code = err?.response?.status;
          if (code !== 404 && code !== 405) throw err;
        }
      }
      throw new Error('Ninguna variante de actualización de proyectos fue aceptada por la API.');
    },
    solicitarEliminarProyecto(proyecto) {
      this.confirmProyecto = { visible: true, proyecto };
    },

    cancelarEliminarProyecto() {
      this.confirmProyecto = { visible: false, proyecto: null };
    },

    async confirmarEliminarProyecto() {
      const proyecto = this.confirmProyecto.proyecto;
      if (!proyecto) return;

      const clientId = this.valToId(this.clienteSeleccionado);
      const areaId = this.valToId(this.areaSeleccionada);

      try {
        await axios.delete(`${API_BASE}/clients/${clientId}/areas/${areaId}/projects/${proyecto.id}`);
        this.showSuccess("Proyecto eliminado en cascada.");
        await this.fetchProyectos();
      } catch (err) {
        console.error("Error eliminando proyecto:", err?.response?.data || err.message || err);
        this.showError("No se pudo eliminar el proyecto.");
      } finally {
        this.cancelarEliminarProyecto();
      }
    },
    async eliminarProyecto(id) {
      const clientId = this.valToId(this.clienteSeleccionado);
      const areaId = this.valToId(this.areaSeleccionada);
      await axios.delete(`${API_BASE}/clients/${clientId}/areas/${areaId}/projects/${id}`);
      await this.fetchProyectos();
    },

    onAddProyecto() {

      this.seleccionarModulo('proyectos');

      if (!this.clientes.length) this.fetchClientes();

      if (this.clienteSeleccionado) this.fetchAreas();

      if (!this.areaSeleccionada) this.areas = [];

      this.abrirEditarProyecto(null);
    },

    async fetchGabinetes() {
      this.gabinetes = [];
      const id = Number(this.proyectoSeleccionado);
      if (!id) return;

      try {
        const { data } = await axios.get(`${API_BASE}/gabinetes`, {
          params: { project_id: id }
        });

        // Normaliza respuesta: array directo o {rows:[]}
        const rows = Array.isArray(data) ? data : (data?.rows ?? []);

        // Filtro defensivo por si el backend no aplicó el query
        this.gabinetes = rows.filter(g =>
          Number(g.project_id ?? g.project?.id) === id
        );
      } catch (err) {
        console.error('fetchGabinetes error:', err?.response?.data || err.message || err);
        this.gabinetes = [];
      }
    },

    async abrirEditarGabinete(gabinete) {
      this.gabineteEditando = gabinete || null;

      // Reset de selects del diálogo
      this.dlgClienteId = null;
      this.dlgAreaId = null;
      this.dlgArchivos = [];
      this.dlgProyectoId = null;
      this.dlgAreas = [];
      this.dlgProyectos = [];
      this.gabineteEditado = gabinete ? { ...gabinete } : { tag: '', type: '', estado: '' };
      this.dlgArchivosSeleccionados = [];
      this.confirmEliminarArch = { visible: false, files: [] };

      if (!gabinete && this.clienteSeleccionado) {
        this.dlgClienteId = this.clienteSeleccionado;
        await this.fetchAreasDlg();
        if (this.areaSeleccionada) {
          this.dlgAreaId = this.areaSeleccionada;
          await this.fetchProyectosDlg();
          if (this.proyectoSeleccionado) {
            this.dlgProyectoId = this.proyectoSeleccionado;
          }
        }
      } else if (gabinete) {
        if (this.clienteSeleccionado) this.dlgClienteId = this.clienteSeleccionado;
        if (this.areaSeleccionada) this.dlgAreaId = this.areaSeleccionada;
        if (this.proyectoSeleccionado) this.dlgProyectoId = this.proyectoSeleccionado;
        // Cargamos listas para que se vean los textos en selects
        if (this.dlgClienteId) await this.fetchAreasDlg();
        if (this.dlgAreaId) await this.fetchProyectosDlg();
        if (gabinete) {
          await this.fetchArchivosGabinete(gabinete.tag || gabinete.id);
        }
      }

      this.dialogoEditarGabinete = true;
    },
    async eliminarGabinete(id) {
      if (!id) return;

      const ok = window.confirm(
        'Esto eliminará el gabinete y sus dependencias (cascada). ¿Deseas continuar?'
      );
      if (!ok) return;

      try {
        await axios.delete(`${API_BASE}/gabinetes/${id}`, { params: { cascade: true } });
        this.showSuccess('Gabinete eliminado en cascada.');
        await this.fetchGabinetes();
      } catch (e) {
        console.error('eliminarGabinete error:', e?.response?.data || e.message || e);
        this.showError('No se pudo eliminar el gabinete.');
      }
    },
    solicitarEliminarGabinete(g) {
      this.confirmGabinete = { visible: true, gabinete: g };
    },

    cancelarEliminarGabinete() {
      this.confirmGabinete = { visible: false, gabinete: null };
    },

    async confirmarEliminarGabinete() {
      const g = this.confirmGabinete.gabinete;
      if (!g) return;

      this.deletingGabinete = true;
      try {
        await axios.delete(`${API_BASE}/gabinetes/${g.id}`, { params: { cascade: true } });
        this.showSuccess("Gabinete eliminado en cascada.");
        await this.fetchGabinetes();
      } catch (err) {
        console.error("Error eliminando gabinete:", err?.response?.data || err.message || err);
        this.showError("No se pudo eliminar el gabinete.");
      } finally {
        this.deletingGabinete = false;
        this.cancelarEliminarGabinete();
      }
    },
    // Helpers
    onDlgClienteChange() {
      this.dlgAreaId = null;
      this.dlgProyectoId = null;
      this.dlgAreas = [];
      this.dlgProyectos = [];
      if (this.dlgClienteId) this.fetchAreasDlg();
    },
    onDlgAreaChange() {
      this.dlgProyectoId = null;
      this.dlgProyectos = [];
      if (this.dlgClienteId && this.dlgAreaId) this.fetchProyectosDlg();
    },

    async fetchAreasDlg() {
      if (!this.dlgClienteId) return;
      const res = await axios.get(`${API_BASE}/clients/${this.dlgClienteId}/areas`);
      this.dlgAreas = res.data || [];
    },

    async fetchProyectosDlg() {
      if (!this.dlgClienteId || !this.dlgAreaId) return;
      const res = await axios.get(`${API_BASE}/clients/${this.dlgClienteId}/areas/${this.dlgAreaId}/projects`);
      this.dlgProyectos = res.data || [];
    },
    async guardarEdicionGabinete() {
      const g = this.gabineteEditado;
      const estadosPermitidos = ['Activo', 'Inactivo', 'En mantención'];
      const estado = String(g.estado || '').trim();

      if (!g.tag?.trim() || !g.type?.trim() || !estado) {
        alert('Completa tag, tipo y estado.');
        return;
      }
      if (!estadosPermitidos.includes(estado)) {
        alert('El estado debe ser: Activo, Inactivo o En mantención.');
        return;
      }

      const projectId = this.dlgProyectoId || this.gabineteEditando?.project_id;
      if (!projectId) {
        alert('Selecciona un proyecto.');
        return;
      }

      const formData = new FormData();
      formData.append('tag', g.tag.trim());
      formData.append('type', g.type.trim());
      formData.append('location', g.location || '');
      formData.append('project_id', String(projectId));
      formData.append('estado', estado);   // 👈 ahora mandamos en español directamente

      const usuario = JSON.parse(sessionStorage.getItem("usuario"));
      formData.append('usuario', usuario?.name || usuario?.correo || 'sistema');

      if (Array.isArray(this.dlgArchivos) && this.dlgArchivos.length > 0) {
        this.dlgArchivos.forEach(file => {
          if (file) formData.append('archivos', file, file.name);
        });
      }

      this.loadingGabinete = true;
      try {
        const url = this.gabineteEditando
          ? `${API_BASE}/gabinetes/${this.gabineteEditando.id}`
          : `${API_BASE}/gabinetes`;
        const method = this.gabineteEditando ? 'put' : 'post';

        for (const [key, value] of formData.entries()) {
          if (value instanceof File) {
            console.log(`➡️ ${key}: FILE - ${value.name} (${value.type}, ${value.size} bytes)`);
          } else {
            console.log(`➡️ ${key}:`, value);
          }
        }

        await axios[method](url, formData);
        await this.fetchGabinetes();

        this.showSuccess(this.gabineteEditando
          ? 'Gabinete actualizado con éxito.'
          : 'Gabinete creado con éxito.');

        this.cerrarDialogoGabinete();
        await this.fetchGabinetes();
      } catch (err) {
        console.error('Error guardando gabinete:',
          err?.response?.status,
          err?.response?.data || err?.message || err
        );
        this.showError('No se pudo guardar el gabinete.');
      } finally {
        this.loadingGabinete = false;
      }
    },

    normalizarEstado(v) {
      if (!v) return '';
      return String(v).trim().toUpperCase().replace(/\s+/g, '_');
    },

    cerrarDialogoGabinete() {
      this.dialogoEditarGabinete = false;
      this.gabineteEditando = null;
      this.gabineteEditado = { tag: '', type: '', estado: '' };
      this.dlgClienteId = null;
      this.dlgAreaId = null;
      this.dlgProyectoId = null;
      this.dlgAreas = [];
      this.dlgProyectos = [];
      this.dlgArchivos = [];
      this.dlgArchivosVinculados = [];
      this.dlgArchivosSeleccionados = [];
    },
    irAGabinete(g) {
      const tag = (g?.tag || '').trim();
      if (!tag) return;
      const url = this.$router.resolve(`/gabinetes/catalogo/tag/${encodeURIComponent(tag)}`).href;
      window.open(url, "_blank");
    },
    async fetchArchivosGabinete(gabineteIdOrTag) {
      this.dlgArchivosVinculados = [];
      if (!gabineteIdOrTag) return;

      const base = (API_BASE || '').replace(/\/$/, '');
      const maybeNum = Number(gabineteIdOrTag);
      const esId = Number.isFinite(maybeNum);

      // 1) Prioriza TAG: si el input no es numérico, o si tienes tag del gabinete en edición
      const tag = !esId ? String(gabineteIdOrTag).trim() : (this.gabineteEditando?.tag || '');
      if (tag) {
        try {
          const res = await axios.get(`${base}/gabinetes/completo-por-tag/${encodeURIComponent(tag)}`);
          const archivos = Array.isArray(res.data?.archivos) ? res.data.archivos : [];
          this.dlgArchivosVinculados = archivos.map(a => {
            const rawUrl = a.url || a.public_url || null;
            const finalUrl = rawUrl
              ? (rawUrl.startsWith('http')
                ? rawUrl.replace(/([^:]\/)\/+/g, '$1')
                : `${base}/${String(rawUrl).replace(/^\//, '')}`.replace(/([^:]\/)\/+/g, '$1'))
              : null;
            return {
              id: a.id,
              name: a.name || a.filename || 'archivo',
              size: a.size ?? a.file_size ?? 0,
              mime: a.tipo || a.mime || a.mimetype || a.content_type || '',
              created_at: a.created_at || a.date || a.uploaded_at || null,
              url: finalUrl,
            };
          }).filter(x => x.id && x.name);
          return;
        } catch (e) {
          console.warn('GET por tag falló, intento por id…', e?.response?.status);
        }
      }

      // 2) Fallbacks por ID
      const id = esId ? maybeNum : Number(this.gabineteEditando?.id);
      if (!Number.isFinite(id)) { this.dlgArchivosVinculados = []; return; }

      const intents = [
        { url: `${base}/gabinetes/${id}/archivos`, pick: d => d?.archivos },
        { url: `${base}/files?cabinet_id=${id}`, pick: d => d },
        { url: `${base}/file?cabinet_id=${id}`, pick: d => d },
      ];

      for (const i of intents) {
        try {
          const res = await axios.get(i.url);
          const raw = i.pick(res.data);
          const archivos = Array.isArray(raw) ? raw : (Array.isArray(res.data) ? res.data : []);
          this.dlgArchivosVinculados = archivos.map(a => {
            const rawUrl = a.url || a.public_url || null;
            const finalUrl = rawUrl
              ? (rawUrl.startsWith('http')
                ? rawUrl.replace(/([^:]\/)\/+/g, '$1')
                : `${base}/${String(rawUrl).replace(/^\//, '')}`.replace(/([^:]\/)\/+/g, '$1'))
              : null;
            return {
              id: a.id ?? a.file_id ?? a._id,
              name: a.name || a.filename || a.file_name || 'archivo',
              size: a.size ?? a.file_size ?? 0,
              mime: a.tipo || a.mime || a.mimetype || a.content_type || '',
              created_at: a.created_at || a.date || a.uploaded_at || null,
              url: finalUrl,
            };
          }).filter(x => x.id && x.name);
          return;
        } catch (e) {
          if (![404, 405].includes(e?.response?.status)) {
            console.warn('fallback por id falló:', i.url, e?.response?.status);
          }
        }
      }

      this.dlgArchivosVinculados = [];
    },

    abrirConfirmEliminarArchivos(files) {
      if (!files || !files.length) return;
      this.confirmEliminarArch = { visible: true, files };
    },

    cancelarEliminarArchivos() {
      this.confirmEliminarArch = { visible: false, files: [] };
    },

    async deleteArchivosMultiples(gabineteId, archivoIds) {
      const usuario = JSON.parse(sessionStorage.getItem("usuario")) || {};
      const nombreUsuario = usuario.name || usuario.correo || 'sistema';

      return axios.delete(
        `${API_BASE}/gabinetes/${Number(gabineteId)}/archivos-multiples`,
        { data: { archivo_ids: archivoIds.map(n => Number(n)), usuario: nombreUsuario } }
      );
    },
    async confirmarEliminarArchivos() {
      const files = this.confirmEliminarArch.files || [];
      if (!files.length) return;

      this.deletingFiles = true;
      const gabineteId = this.gabineteEditando?.id;
      const archivoIds = files.map(f => f.id);

      try {
        await this.deleteArchivosMultiples(gabineteId, archivoIds);
        this.showSuccess(files.length === 1 ? 'Archivo eliminado.' : `${files.length} archivos eliminados.`);
        this.dlgArchivosSeleccionados = [];
        await this.fetchArchivosGabinete(this.gabineteEditando?.tag || this.gabineteEditando?.id);
      } catch (e) {
        console.error('Borrar archivos múltiples error:', e?.response?.data || e);
        this.showError('No se pudieron eliminar uno o más archivos.');
      } finally {
        this.deletingFiles = false;
        this.cancelarEliminarArchivos();
      }
    },
    eliminarArchivoFila(file) {
      this.abrirConfirmEliminarArchivos([file]);
    },
    eliminarArchivosSeleccionados() {
      const chosen = (this.dlgArchivosSeleccionados || []).map(f => ({
        id: f.id, name: f.name, size: f.size, mime: f.mime
      })).filter(f => f.id);
      if (!chosen.length) return;
      this.abrirConfirmEliminarArchivos(chosen);
    },
    //HELPERS
    formatBytes(bytes) {
      const b = Number(bytes || 0);
      if (!b) return '0 B';
      const k = 1024, sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(b) / Math.log(k));
      return `${(b / Math.pow(k, i)).toFixed(i ? 1 : 0)} ${sizes[i]}`;
    },
    formatFechaArchivo(v) {
      if (!v) return '';
      try {
        let d;
        if (typeof v === 'number') d = new Date(v);
        else if (String(v).includes('T')) d = new Date(v);
        else d = new Date(String(v));
        if (isNaN(d)) return String(v);
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yy = d.getFullYear();
        return `${dd}-${mm}-${yy}`;
      } catch { return String(v); }
    },
    //
    volverInicio() {
      this.$router.push("/inicio").catch(() => { });
    },
    showSuccess(msg, title = 'Operación exitosa') {
      this.showFeedback('success', msg, title);
    },
    showError(msg, title = 'Ocurrió un problema') {
      this.showFeedback('error', msg, title);
    },
    showFeedback(type, message, title) {
      const map = {
        success: { color: 'green darken-2', icon: 'mdi-check-circle' },
        error: { color: 'red darken-2', icon: 'mdi-alert-circle' }
      };
      const sty = map[type] || map.success;
      this.feedback = { visible: true, message, title, ...sty };

      clearTimeout(this.feedbackTimer);
      this.feedbackTimer = setTimeout(() => {
        this.feedback.visible = false;
      }, 2200);
    },
  }
}
</script>

<style scoped>
.container-custom {
  max-width: 1200px;
  margin: auto;
}

.hoverable {
  transition: 0.2s;
  cursor: pointer;
}

.hoverable:hover {
  background-color: #f5f5f5;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.gab-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  transition: filter .15s ease, background-color .15s ease;
}

.gab-item:hover {
  filter: brightness(0.96);
  background-color: rgba(0, 0, 0, .04);
}

.gab-item:active {
  filter: brightness(0.92);
}


.row-link {
  cursor: pointer;
}

.actions {
  transition: opacity .15s ease;
}

.gab-item .actions {
  opacity: 0.85;
}

.gab-item:hover .actions {
  opacity: 1;
}

.global-dashboard-card {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.theme--light .global-dashboard-card {
  background-color: #ffffff;
  color: #27282a;
}

.theme--dark .global-dashboard-card {
  background-color: #27282a;
  color: #ffffff;
}

.global-dashboard-card .v-data-table {
  border-radius: 12px;
}
</style>